import { render, staticRenderFns } from "./PgaRequestChangesButton.vue?vue&type=template&id=4a879b3c&"
import script from "./PgaRequestChangesButton.vue?vue&type=script&lang=ts&"
export * from "./PgaRequestChangesButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a879b3c')) {
      api.createRecord('4a879b3c', component.options)
    } else {
      api.reload('4a879b3c', component.options)
    }
    module.hot.accept("./PgaRequestChangesButton.vue?vue&type=template&id=4a879b3c&", function () {
      api.rerender('4a879b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/PgaRequestChangesButton.vue"
export default component.exports